module.exports = __webpack_public_path__ + "static/media/img-company-success-2-mobile@2x.481f807b.png";